export default {
  title: "關於我們",
  mission_vision: "使命與願景",
  mission_vision_desc:
    "我們的使命是幫助中小企業快速實現歐盟CBAM合規，準確率超過90%，降低成本，提高效率，並支持2026年可持續發展目標。",
  team: "團隊介紹",
  team_desc:
    "TaxEcoBit是由專業團隊構建的CBAM合規SaaS平台，致力於為中小企業提供高效可靠的工具，簡化合規流程，並持續更新以滿足歐盟監管要求。",
  contact: "聯繫我們",
  contact_email: "郵箱：{email}",
  follow_us: "關注我們：",
  newsletter: "新聞訂閱",
  newsletter_desc: "訂閱我們的新聞通訊，獲取最新的CBAM政策解讀、合規提示和功能更新。",
  newsletter_button: "訂閱",
  agreement_text:
    "我同意使用此郵箱接收最新的CBAM政策解讀、合規提示和功能更新，並同意根據GDPR要求處理我的個人數據。",
  support: "即時支持",
  support_desc:
    "我們已整理常見問題供您快速自助查詢；如需進一步幫助，可隨時提交工單，我們的支持團隊將在24-48小時內回復。",
  support_button: "聯繫支持",
  chat_opened: "支持窗口已打開",
  newsletter_success: "訂閱成功：{email}",
};
